import { render, staticRenderFns } from "./courseProgressCard.vue?vue&type=template&id=52474b0e&scoped=true&"
import script from "./courseProgressCard.vue?vue&type=script&lang=js&"
export * from "./courseProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./courseProgressCard.vue?vue&type=style&index=0&id=52474b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52474b0e",
  null
  
)

export default component.exports